import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs';
import { AuthService } from '@core/services/api/auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const router = inject(Router);
    const authService = inject(AuthService);

    return next(req).pipe(
        tap({
            error: (error) => {
                if (error.status === 401) {
                    authService.purgeAuth();
                    router.navigate(['/auth/login']);
                } else if (error.status === 503) {
                    router.navigate(['/error/503']);
                }
            }
        })
    );
};
